import style from "./Home.Module.css";
import odesaPanorama from "../../img/Odesa/Pnorama1.jpg";
import botevPicture from "../../img/Botev/hol1.jpg";
import { Link } from "react-router-dom";
import { LangContext } from "../../contexts/Language";
import { useContext, useEffect } from "react";

export const Home = () => {
    const { lang } = useContext(LangContext);

    useEffect(() => {
        document.title = 'Апартаменти под наем в Созопол | Нощувки с морска гледка';
    }, []);

    if (lang === 'BG') {
        return (
            <section className="home-section">
                <div className="apartments">
                    <Link to="/Odessa" className="link">
                        <div className="home-card">
                            <img src={odesaPanorama} alt="apartment-odesa" />
                            <div className="card-overlay">
                                <h4>АПАРТАМЕНТ ОДЕСА</h4>
                                <p>
                                    До плаж „Харманите" — усетете морето от прозореца си.
                                </p>
                                <span className="card-cta">Виж повече →</span>
                            </div>
                        </div>
                    </Link>

                    <Link to="/Botev" className="link">
                        <div className="home-card">
                            <img src={botevPicture} alt="apartment-hristo-botev" />
                            <div className="card-overlay">
                                <h4>АПАРТАМЕНТ ХРИСТО БОТЕВ</h4>
                                <p>
                                    Между Централен плаж и „Харманите" — уют и спокойствие за вашата почивка.
                                </p>
                                <span className="card-cta">Виж повече →</span>
                            </div>
                        </div>
                    </Link>
                </div>
            </section>
        );
    }

    if (lang === 'RU') {
        return (
            <section className="home-section">
                <div className="apartments">
                    <Link to="/Odessa" className="link">
                        <div className="home-card">
                            <img src={odesaPanorama} alt="apartment-odesa" />
                            <div className="card-overlay">
                                <h4>АПАРТАМЕНТ ОДЕССА</h4>
                                <p>
                                    Рядом с пляжем Харманите — почувствуйте море из окна.
                                </p>
                                <span className="card-cta">Подробнее →</span>
                            </div>
                        </div>
                    </Link>

                    <Link to="/Botev" className="link">
                        <div className="home-card">
                            <img src={botevPicture} alt="apartment-hristo-botev" />
                            <div className="card-overlay">
                                <h4>АПАРТАМЕНТ ХРИСТО БОТЕВ</h4>
                                <p>
                                    Между Центральным пляжем и Харманите — уют и спокойствие для вашего отдыха.
                                </p>
                                <span className="card-cta">Подробнее →</span>
                            </div>
                        </div>
                    </Link>
                </div>
            </section>
        );
    }

    if (lang === 'CZ') {
        return (
            <section className="home-section">
                <div className="apartments">
                    <Link to="/Odessa" className="link">
                        <div className="home-card">
                            <img src={odesaPanorama} alt="apartment-odesa" />
                            <div className="card-overlay">
                                <h4>APARTMÁN ODESSA</h4>
                                <p>
                                    U pláže Harmanite — cítěte moře z okna.
                                </p>
                                <span className="card-cta">Zobrazit více →</span>
                            </div>
                        </div>
                    </Link>

                    <Link to="/Botev" className="link">
                        <div className="home-card">
                            <img src={botevPicture} alt="apartment-hristo-botev" />
                            <div className="card-overlay">
                                <h4>APARTMÁN HRISTO BOTEV</h4>
                                <p>
                                    Mezi Centrální pláží a Harmanite — pohodlí a klid pro váš dokonalý pobyt.
                                </p>
                                <span className="card-cta">Zobrazit více →</span>
                            </div>
                        </div>
                    </Link>
                </div>
            </section>
        );
    }

    if (lang === 'EN') {
        return (
            <section className="home-section">
                <div className="apartments">
                    <Link to="/Odessa" className="link">
                        <div className="home-card">
                            <img src={odesaPanorama} alt="apartment-odesa" />
                            <div className="card-overlay">
                                <h4>APARTMENT ODESSA</h4>
                                <p>
                                    Next to Harmanite beach — feel the sea from your window.
                                </p>
                                <span className="card-cta">View more →</span>
                            </div>
                        </div>
                    </Link>

                    <Link to="/Botev" className="link">
                        <div className="home-card">
                            <img src={botevPicture} alt="apartment-hristo-botev" />
                            <div className="card-overlay">
                                <h4>APARTMENT HRISTO BOTEV</h4>
                                <p>
                                    Between Central Beach and Harmanite — comfort and cosiness for your perfect stay.
                                </p>
                                <span className="card-cta">View more →</span>
                            </div>
                        </div>
                    </Link>
                </div>
            </section>
        );
    }
};
